module.exports = __webpack_public_path__ + "static/media/6.bcf1045b.jpg";